import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33b96005"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal-content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal fixed top-0 left-0", [_ctx.size]])
  }, [
    _createVNode(_Transition, { name: "modal-background" }, {
      default: _withCtx(() => [
        (_ctx.isModalOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              ref: "modalContainer",
              class: "modal-background w-screen h-screen bg-black bg-opacity-20 z-40",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, null, 512))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "modal-content" }, {
      default: _withCtx(() => [
        (_ctx.isModalOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _renderSlot(_ctx.$slots, "default", { closeModal: _ctx.closeModal }, undefined, true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ], 2))
}